import React from 'react';
import * as Opt from '../editor/Helpers';
import ColorSelector from '../editor/fields/ColorSelector';

class HeroMetric extends React.Component {
    constructor() {
        super();

        this.state = {
            activeItem: 0
        }
    }


    render() {
        return (
            <div className={`${window.location.pathname.includes('editor') && (["dt", "mob"].filter((i) => i === this.props.visibility).length) ? 'opacity-50 flex' : this.props.visibility == "dt" ? 'hidden lg:flex' : this.props.visibility == "mob" ? 'lg:hidden' : 'flex'} bg-${this.props.backgroundColor}`} style={{ padding: `${isNaN(this.props.morePadding) ? this.props.morePadding : this.props.morePadding+'px'}`}}>
                <div className={`p-0 container`}>
                        <div className='flex flex-wrap px-1 py-[3rem] justify-between'>
                            {this.props.cards.map((card) => {
                                return <div className={`w-1/2 md:w-1/4 pb-2`}>
                                    <div className={`ml-1 mb-1 border-0 flex flex-col justify-end items-start pl-4 bg-${this.props.containterBackgroundColor}`} style={{ borderRadius: "0px 192px 0px 0px", alignItems: "end", height: "200px", width: "100%" }}>
                                        <p className={`${card.textColor} fs-1 font-bold`}>{card.value} </p>
                                        <p className={`${card.textColor} fs-6 font-normal`}>{card.text}</p>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
        )
    }
}
HeroMetric.defaultProps = {
    morePadding: "0",
    visibility: "",
    backgroundColor: 'white-50',
    containterBackgroundColor: 'neutral-cloud',
    cards: [{ value: "65000+", text: "Medlemmar", textColor: "neutral-charcoal" }, { value: "29%", text: "Högre virkespriser" }, { value: "1500+", text: "Virkesköpare", textColor: "neutral-charcoal"  }, { value: "Value", text: "Label", textColor: "neutral-charcoal" }],
}
HeroMetric.fields = {
    backgroundColor: {
        type: "custom",
        render: (props) => <ColorSelector {...props} />
      },
      visibility: {
        type: "select",
        options: Opt.visibilityOptions
      },
    containterBackgroundColor: {
        type: "select",
        options: Opt.colorVariables
      },
    cards: {
        type: "array",
        arrayFields: {
            value: { type: "text" },
            text: { type: "text" },
            textColor: {
                type: "select",
                options: Opt.colorVariables
            },
        },
        defaultItemProps: HeroMetric.defaultProps.cards[3],
    },
    morePadding: {
        type: "text",
    },
}
export default HeroMetric;
